// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateLaborStatsSearchCriteria = (state, action) => action.partNumber;

const resetLaborStatsSearchCriteria = () => getDefaultState().partNumberSearchCriteria;

export default (state = getDefaultState().partNumberSearchCriteria, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_STATS_SEARCH_CRITERIA]: updateLaborStatsSearchCriteria,
        [actions.RESET_LABOR_STATS_REPORT]: resetLaborStatsSearchCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/labor-stats/reducers/criteria.js